// Globaler Sortier-Patch für linq-to-typescript (numerischer Default-Comparer).
// Muss vor jeder orderBy/thenBy-Nutzung und vor dem Bootstrap geladen werden.
import './app/utils/linq-sort-patch';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { User } from './app/data/entities';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
     platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
   });
